import { render, staticRenderFns } from "./LayoutTableBuilder.vue?vue&type=template&id=5c2f73ac&scoped=true&"
import script from "./LayoutTableBuilder.vue?vue&type=script&lang=js&"
export * from "./LayoutTableBuilder.vue?vue&type=script&lang=js&"
import style0 from "./LayoutTableBuilder.vue?vue&type=style&index=0&id=5c2f73ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2f73ac",
  null
  
)

export default component.exports